import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

export const NoviosFeedback = () => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const isWedding = isWeddingFlow();

  if (!isWedding) return <></>;
  if (!cart?.clubParisCode) return <></>;

  return (
    <div className="co-w-full co-flex co-rounded-8px co-py-8px co-px-16px co-gap-8px co-bg-[#E4F7E0] co-border-1 co-border-[#B2E4A8]">
      <div className="co-flex co-gap-8px co-items-center">
        <Icon icon="EngagementRingIcon" width={32} height={32} />
        <div className="co-flex co-flex-col co-gap-2px">
          <Typography
            weight="semibold"
            className="co-text-[#002D83]"
            color="#002D83"
          >
            {'Código Novios Paris:'} {cart?.clubParisCode}
          </Typography>
          <Typography
            weight="semibold"
            className="co-text-[#002D83]"
            color="#002D83"
            noWrap
          >
            {'Pareja: '}
            <span className="co-font-normal">
              {cart?.weddingFirstName1} y {cart?.weddingFirstName2}
            </span>
          </Typography>
        </div>
      </div>
    </div>
  );
};
